import { displayRole } from "@modules/boxStaff/entities/boxStaffUtils"
import { BoxStaffStatus } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffs } from "@modules/boxStaff/hooks/useBoxStaff"
import { InputContainer } from "@modules/formik/components/inputContainer"
import { UserCell } from "@modules/members/components/userCell"
import { FieldValueChange } from "@src/typings/formik"
import { FieldInputProps } from "formik"

type SearchStaffInputProps<T, K> = {
  label: string
  name: string
  isRequiredInput: boolean
  isInvalid: boolean
  setFieldValue: FieldValueChange<K>
  getFieldProps: (nameOrOptions: T) => FieldInputProps<any>
  error?: React.JSX.Element
  className?: string
  filterByStatus?: BoxStaffStatus[]
} & React.ComponentProps<"div">

export function SearchStaffInput<T, K>({
  label,
  name,
  isRequiredInput,
  isInvalid,
  setFieldValue,
  getFieldProps,
  error,
  className,
  filterByStatus,
  ...props
}: SearchStaffInputProps<T, K>) {
  const { data } = useBoxStaffs(0, 50)
  const filteredData = filterByStatus
    ? data.content.filter((staffPerson) => filterByStatus.includes(staffPerson.status))
    : data.content
  const staffIdSelected = getFieldProps(name as string as T).value as string | undefined

  const defaultClassName = "flex flex-column gap-3 w-full"
  const selectedVariant = "border-2 border-purple-500"
  const neutralVariant = "border-1 border-neutralColor-200"
  const unselectedVariant = "border-1 border-neutralColor-200 opacity-50"

  function handleClick(staffId: string) {
    setFieldValue(name, staffId)
  }

  return (
    <InputContainer
      isRequiredInput={isRequiredInput}
      label={label}
      name={name}
      isInvalid={isInvalid}
      error={error}
      className={className ?? defaultClassName}
      {...props}
    >
      <div className="grid">
        {filteredData.map((staffPerson, index) => (
          <div className="col-6" key={index}>
            <UserCell
              key={staffPerson.id}
              member={{
                avatar: staffPerson.avatar,
                username: staffPerson.username,
                firstname: staffPerson.firstname,
                lastname: staffPerson.lastname,
              }}
              subtitle={displayRole(staffPerson.role)}
              avatarSize={40}
              className={`flex gap-2 justify-content-center cursor-pointer border-round-2xl px-2 py-3
                ${!staffIdSelected ? neutralVariant : ""}
                ${staffIdSelected === staffPerson.id ? selectedVariant : ""}
                ${staffIdSelected && staffIdSelected !== staffPerson.id ? unselectedVariant : ""}`}
              onClick={() => handleClick(staffPerson.id)}
            />
          </div>
        ))}
      </div>
    </InputContainer>
  )
}
